import React from 'react';
import { useSelector } from 'react-redux';
import { AngularContext } from 'react-app';
import useAngularExpression from 'shared/hooks/use-angular-expression';
import { getCurrentInstitution } from 'redux/selectors/institutions';
import MentorPlusPromo from 'athena/components/mentor-plus-promo';
import { config } from '@config/pendo.config.json';

const LhsPromos = () => {
  const { injectServices } = React.useContext(AngularContext);
  const [$state, CurrentPermissionsManager, CurrentUserManager] = injectServices([
    '$state',
    'CurrentPermissionsManager',
    'CurrentUserManager',
  ]);
  const isOrgAdmin = CurrentPermissionsManager.hasOrgAdminPermissions();
  const isCourseManager = CurrentPermissionsManager.hasCourseManagerPermissions();
  const isCourseAdmin = CurrentUserManager.isCourseAdminInAtLeastOneCourse();

  const { isMentorshipEnabled } = useSelector(getCurrentInstitution);

  const hasAdminRole = isOrgAdmin || isCourseManager || isCourseAdmin;

  const isLhsExpanded = useAngularExpression(
    () => $state.current.data.expandedLHS,
  );

  const promos = [];

  if (!isMentorshipEnabled) {
    promos.push({
      Component: MentorPlusPromo,
      dataQa: config.pendo.athena.mentorPlusInProductPromo,
    });
  }

  return hasAdminRole ? (
    <ul className='pl-0 mb-0'>
      {promos.length
        ? promos.map(({ Component, dataQa }) => (
          <Component isExpanded={isLhsExpanded} dataQa={dataQa} />
        ))
        : null}
    </ul>
  ) : null;
};

export default LhsPromos;
